import React from 'react';
import { UsageRightStatus } from './types';
import styles from '../../../styles/usageRights.module.css';
import XIcon from '../../../assets/icons/XIcon';

const FilterChipColorMap = {
  pending: {
    color: 'var(--text-blue)',
    text: 'New Request',
  },
  accepted: {
    color: 'var(--text-success)',
    text: 'Approved',
  },
  rejected: {
    color: 'var(--critical-r-500)',
    text: 'Rejected',
  },
  negotiation: {
    color: 'var(--text-yellow)',
    text: 'Negotiation',
  },
};

interface FilterChipProps {
  status: UsageRightStatus;
  onCrossClick?: () => unknown;
}

function FilterChip({ status, onCrossClick }: FilterChipProps) {
  console.log({ status });
  return (
    <div className={styles.filterChipContainer}>
      <div className={styles.filterChipContainerTitle}>
        Status: <span style={{ color: FilterChipColorMap?.[status]?.color }}>{FilterChipColorMap?.[status].text}</span>
      </div>
      <XIcon onClick={onCrossClick} style={{ cursor: 'pointer' }} />
    </div>
  );
}

export default FilterChip;
